module.exports = __webpack_public_path__ + "img/pinguinitos-bg.jpg.c02582c3.webp";